import { inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';

export const selectTranslate = (...args: Parameters<TranslocoService['selectTranslate']>): Observable<unknown> =>
  inject(TranslocoService).selectTranslate(...args);
